import { ResourceSerializer } from "./rest-resource.interface";

export class GenericAPIResource implements ResourceSerializer {
  fromJson(json: any) {
    return json;
  }
  toJson(resource: any) {
    return resource;
  }
  Code: number;

}

export class GenericListApiResource extends GenericAPIResource {
  list: any;
}
export class GenericElementResource extends GenericAPIResource {
  element: any;
}

export class GenericMessageResource extends GenericAPIResource {
  message: string;
}
